export default "__VITE_ASSET__f27c6113__"